// extracted by mini-css-extract-plugin
export default {"appContainer":"App_appContainer__Q73Qs","title":"App_title__YS7Xx","overlay":"App_overlay__22cjI"};